<div siqGrid fx-direction="column">
  <div siqGrid fx-layout-align="space-between center" fx-direction="row" class="background-transparent cursor-pointer" [style.height]="height">
      @for(tab of tabs; track $index; let i = $index) {
        <div siqGrid
           (click)="selectTab(i)"
           fx-layout-align="center center"
           [style.width]="'calc(100% / ' + tabs.length +')'">
          <div class="tab-text siq-text-700 fs-14" [class.white]="isTabSelected(i)" [class.primary-200]="!isTabSelected(i)">{{ tab }}</div>
        </div>
      }
  </div>
  <div class="active-tab background-white"
       [style.width]="'calc(100% / ' + tabs.length +')'"
       [style.margin-left]="'calc(' + selectedTab + '*(100% / ' + tabs.length +'))'">
  </div>
</div>
